import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { LookingText, PhoneText } from './LookingLocation';
import { useSelector } from 'react-redux';
import {
	selectBrowserCoords,
	selectCountryData,
	selectInitCoords,
} from '../../store/map';
import Map from '../welcome/components/Map';
import { AppButton } from '../../components';
import { sendAnalyticsEvents } from '../../analytics/common';
import { EVENTS } from '../../analytics/events';
import { useNavigate } from 'react-router-dom';
import { selectEventsData } from '../../store/events';
import { useEffect, useState } from 'react';

const ApproximateText = styled(LookingText)``;
const LocationText = styled(PhoneText)``;
export const extraMapStyles = css`
	position: static;
	margin-top: 30px;
	border-radius: 32px;
	min-height: unset;
`;
const ApproximateLocation = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const countryData = useSelector(selectCountryData);
	const initCoords = useSelector(selectInitCoords);
	const { browserLat, browserLng } = useSelector(selectBrowserCoords);
	const [initEventSent, setInitEventStatus] = useState(false);
  const eventsData = useSelector(selectEventsData);

  useEffect(() => {
    if (initEventSent) return;
    sendAnalyticsEvents(EVENTS.onboardingAprxLocationShown, eventsData);
    setInitEventStatus(true)
  }, [eventsData, initEventSent]);

	const onGetLocationClick = () => {
		sendAnalyticsEvents(EVENTS.onboardingAprxLocationSubmitted, eventsData);
		navigate('/signup');
	};

	return (
		<>
			<ApproximateText>{t('approximate_location')}</ApproximateText>
			<LocationText>
				{countryData.city}, {countryData.country_code}
			</LocationText>
			<Map
				lat={browserLat || initCoords.lat}
				lng={browserLng || initCoords.lng}
				customHeight={'350px'}
				customWidth={'330px'}
				customStyles={extraMapStyles}
				zoom={7}
			/>
			<AppButton
				onClick={onGetLocationClick}
				bottomPosition={'16px'}
				customText={t('get_precise_location')}
			/>
		</>
	);
};

export default ApproximateLocation;
